import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import { unicodeToString } from "../../../../Js/Common";

const pathToParentMenu = ["root"];

const WwHeading = (props) => {
  const [classnames, setClassnames] = useState("");

  useEffect(() => {
    // if (props.data && props.data.class) {
    //   setClassnames(props.data.class);
    // }
  }, [props.data]);

  return (
    <>
      {props.data && props.data.source && (
        <Grid container sx={{padding: '8px'}}>
          <Grid item xs={12}>
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "20px",
                fontWeight: "500",
                ml: 1,
                px: 2,
                '@media (min-width: 1636px)':{
                  fontSize: '1.6rem'
                }
              }}
            >
              <div
                className={classnames}
                id={props.data.myId.self}
                dangerouslySetInnerHTML={{
                  __html: unicodeToString(props.data.source),
                }}
                style={{display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}
              ></div>
            </Typography>
            <Divider sx={{ bgcolor: "primary.light", mt: 0.6 }}></Divider>
          </Grid>
        </Grid>
      )}
    </>
  );
};
export default WwHeading;
